// @flow

import React from 'react'
import type { Message } from 'types/message'
import type { PacketResponse } from 'types/packet-response'
import type { Response } from 'types/response'

function useResponseSendReminder(
  response: ?Response,
  packetResponse: ?PacketResponse,
  message: ?Message
): [
  boolean,
  boolean,
  (boolean) => void,
  { title: string, onClick: () => void, loading: boolean }
] {
  const [isSendingReminder, setIsSendingReminder] = React.useState(false)
  const showSendReminder =
    !(response?.is_submitted || packetResponse?.is_submitted) &&
    message?.message_type !== 'internal'

  const sendReminder = React.useMemo(
    () => ({
      title: 'Send Reminder',
      onClick: () => {
        setIsSendingReminder(true)
      },
      loading: isSendingReminder,
    }),
    [isSendingReminder]
  )

  return [
    showSendReminder,
    isSendingReminder,
    setIsSendingReminder,
    sendReminder,
  ]
}

export default useResponseSendReminder
